export const ErrorDefaultValueWidget = ({displayError}: {
  displayError: boolean;
}) => {
  return (
    <div>
      {displayError && (
        <div className="error-text">
          La valeur par défaut est incorrecte, veuillez la
          corriger ou saisir une valeur afin de l'écraser
        </div>
      )}
    </div>
  );
};
